import {LIMIT_PAGE_DEFAULT} from "@/shared/constant";
import {NotificationReadStatus} from "@/modules/account";

export class NotificationParams {
    page? = 1;
    limit? = 5;
    readStatus?: undefined;
}